import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { applyMode, getStoredMode } from "@/lib/useBackendDarkTheme";

/** Hell/Dunkel-Umschalter für das komplette Backend. Wahl wird pro Nutzer gespeichert. */
export const ThemeModeToggle = ({ className = "" }) => {
  const { user } = useAuth();
  const [mode, setMode] = useState(getStoredMode);

  // Serverseitige Nutzerpräferenz nur beim ersten Kontakt mit diesem Nutzer übernehmen –
  // danach gilt die lokale Wahl (sonst überschreibt der /auth/me-Response ein frisches Umschalten).
  useEffect(() => {
    if (!user?.id) return;
    if (localStorage.getItem("yg_backend_mode_uid") === user.id) return;
    localStorage.setItem("yg_backend_mode_uid", user.id);
    const pref = user.ui_theme === "dark" ? "dark" : "light";
    applyMode(pref);
    setMode(pref);
  }, [user]);

  const toggle = () => {
    const next = mode === "dark" ? "light" : "dark";
    applyMode(next);
    setMode(next);
    if (user?.id) localStorage.setItem("yg_backend_mode_uid", user.id);
    api.put("/me/ui-theme", { theme: next }).catch((e) => console.warn("Theme konnte nicht gespeichert werden:", e?.message));
  };

  return (
    <button
      onClick={toggle}
      title={mode === "dark" ? "Hellen Modus einschalten" : "Dunklen Modus einschalten"}
      aria-label={mode === "dark" ? "Hellen Modus einschalten" : "Dunklen Modus einschalten"}
      data-testid="theme-mode-toggle"
      data-mode={mode}
      className={`grid place-items-center w-9 h-9 rounded-lg border border-[var(--line-strong)] bg-[var(--surface-2)] text-[var(--ink)] hover:bg-[var(--surface-3)] transition-colors ${className}`}>
      {mode === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};
